import { useUIStore } from "@/store/ui/ui-store";
import Link from "next/link";
import { IoMdClose } from "react-icons/io";

interface Props {
  /** A donde lleva el logo. Por defecto /admin (comportamiento historico). */
  href?: string;
  collapsed?: boolean;
}

export const MenuLogo = ({ href = "/admin", collapsed = false }: Props) => {

  const closeMenu = useUIStore((state) => state.closeSideMenu);

  return (
    <div className="flex min-w-0 items-center gap-2">
      <Link href={href} className="block">
        <img
          src="/img/logo-response.webp"
          alt="Colegio Albert Einstein"
          className={collapsed ? "h-8 w-8 object-contain" : "h-[46px] w-auto"}
        />
      </Link>
      <button
        onClick={closeMenu}
        aria-label="Cerrar menú"
        className="grid place-items-center rounded-md p-2 text-[var(--nav-fg)] hover:bg-[var(--nav-hover-bg)] lg:hidden"
      >
        <IoMdClose size={18} />
      </button>
    </div>
  );
};
